import { apiVersion } from './apis.const';
import { transformResponse } from './apis.util';
import { baseApi } from './base.api';

/**
 * API Urls
 */
const searchUrl = ({ orgSlug, search }: { orgSlug: string; search: string }) =>
  `/${orgSlug}/${apiVersion}/search?q=${search}`;

/**
 * Create APIs
 */
export const searchApi = baseApi.injectEndpoints({
  overrideExisting: false,

  endpoints: (build) => ({
    fetchSearchResult: build.query<FetchSearchResultRes, FetchSearchResultReq>({
      query: ({ orgSlug, search }) => ({
        url: searchUrl({ orgSlug, search }),
      }),
      transformResponse,
    }),
  }),
});

/**
 * Hooks
 */
export const { useFetchSearchResultQuery } = searchApi;

/**
 * Types
 */
type FetchSearchResultRes = any;
type FetchSearchResultReq = {
  orgSlug: string;
  search: string;
};
